import { useUserDataStore } from '../newStore/userDataStore';

export function useFeatureFlags() {
  const { featureFlags, premiumFlags, premiumFeatures, loading } = useUserDataStore();

  const checkFlag = (flagToCheck: string) => {
    if (!featureFlags) return false;
    return featureFlags.some((flag: string) => flagToCheck === flag);
  };

  const getPremiumFlag = (flagToGet: string) => {
    if (!(flagToGet in premiumFlags)) return null;
    return premiumFlags[flagToGet];
  };

  const getPremiumFeature = (featureToGet: string) => {
    if (!(featureToGet in premiumFeatures)) return null;
    return premiumFeatures[featureToGet];
  };

  return {
    featureFlags,
    loading,
    checkFlag,
    getPremiumFlag,
    getPremiumFeature,
  };
}
